import { useRegisterFormStore } from '/@/store/modules/registerForm';
import { useGo } from '/@/hooks/web/usePage';
import { PageEnum } from '/@/enums/pageEnum';

export const useBecomeMember = () => {
  const registerFormStore = useRegisterFormStore();
  const go = useGo();
  const handleBecomeMember = () => {
    // 判断是否已申请过
    // 已申请过，则直接跳转到注册页
    if (registerFormStore.id) {
      go(PageEnum.ACCOUNT_REGISTER);
      return;
    }

    // TODO: 判断跳转到注册页面还是协议页
    go(PageEnum.ACCOUNT_AGREEMENT);
  };
  return { handleBecomeMember };
};
